module.exports = __webpack_public_path__ + "1993c908ee635cd152b71bce1962fe2a.jpg";